export function loadDefaultAttributes(ctx, attributes) {
    return ctx.dispatch('LOAD_INITIAL_ATTRIBUTES', attributes);
}
